import { FacadeService } from "./../../service/facade.service";
import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  PLATFORM_ID,
  ChangeDetectorRef,
  LOCALE_ID
} from "@angular/core";
import { WINDOW } from "@ng-toolkit/universal";
import {
  trigger,
  state,
  style,
  transition,
  animate
} from "@angular/animations";
import { Router, NavigationEnd } from "@angular/router";
import { Location, isPlatformBrowser } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

interface Menu {
  name: string;
  path: string;
  active: boolean;
  subMenu?: Array<Menu>;
}

@Component({
  host: {
    "(document:click)": "onClick($event)"
  },
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
  animations: [
    trigger("toogle", [
      state(
        "initial",
        style({
          opacity: 1
        })
      ),
      state(
        "final",
        style({
          opacity: 0
        })
      ),
      transition("initial=>final", animate("300ms")),
      transition("final=>initial", animate("300ms"))
    ])
  ]
})
export class NavBarComponent implements OnInit {
  currentLang = "en";
  state = false;
  toogleState = "initial";
  menus: Menu[];
  categories;
  currentItem;
  lastUrl;

  constructor(
    @Inject(WINDOW) private WINDOW,
    @Inject(PLATFORM_ID) private platfromId,
    @Inject(LOCALE_ID) private locale,
    private _eref: ElementRef,
    private _router: Router,
    private _FacadeService: FacadeService,
    private _location: Location,
    private translate: TranslateService,
    private router: Router
  ) {
    this.currentLang = this.locale;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.lastUrl = event.url;
      }
    });
  }

  ngOnInit() {
    this.setMenu();
    this.getCurrentRoute();
    if (isPlatformBrowser(this.platfromId)) {
      this.sticky();
    }
  }

  setMenu() {
    this.menus = [
      {
        name: this.currentLang === "en" ? "Home" : "الرئيسية",
        path: "/",
        active: true
      },
      {
        name: this.currentLang === "en" ? "About us" : "من نحن",
        path: "about-us",
        active: false
      },
      {
        name: this.currentLang === "en" ? "Products" : "المنتجات",
        path: "products",
        active: false,
        subMenu: []
      },
      {
        name: this.currentLang === "en" ? "Projects" : "المشاريع",
        path: "projects",
        active: false
      },
      {
        name: this.currentLang === "en" ? "Contact us" : "تواصل معنا",
        path: "contact-us",
        active: false
      }
    ];
    this.getAllCatogeries();
  }

  getCurrentRoute() {
    const currentRoute = this._location.path().split("/")[1];
    this.currentItem = currentRoute;
  }

  /**
   * view hide nav bar content
   *
   *
   */
  viewNavData() {
    if (this.toogleState == "initial") {
      this.toogleState = "final";
    } else {
      this.toogleState = "initial";
    }

    this.state = !this.state;
  }

  sticky() {
    window.onscroll = () => {
      myFunction();
    };

    const header = document.getElementById("sticky");
    const sticky = header.offsetTop;

    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add("opp");
      } else {
        header.classList.remove("opp");
      }
    }
  }

  changeSelection(selectedItem: Menu) {
    this.currentItem = selectedItem.path;
    if (!selectedItem.subMenu) {
      this._router.navigate([selectedItem.path]);
      this.state = false;
    }
  }

  onClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      if (this.WINDOW.innerWidth < 770) {
        this.state = false;
      }
    }
  }
  /**
   * typing on search input
   * @param $event
   */
  onKeyUP(event) {
    // if press enter
    if (event.code == "Enter") {
      this.goToSearchPage(event.target);
    }
  }

  /**
   * search navgation to search page
   * @param searchInput  input element
   */
  goToSearchPage(searchInput) {
    // get value
    const value = searchInput.value;

    this._router.navigate(["/products/search", value]);
  }
  // get all catogery
  getAllCatogeries() {
    this._FacadeService.Product.categories.subscribe(res => {
      this.categories = res.data;
      this.menus[2].subMenu = [
        {
          path: "/products",
          name: this.currentLang === "en" ? "all" : "الكل",
          active: false
        },
        ...this.categories.map(ele => {
          return {
            path: "/products/" + ele.id,
            name: ele.name,
            active: false
          };
        })
      ];
    });
  }
}
